import { MetaField } from '@rossum/api-client/shared';
import { getModifierValueOptions } from '../helpers';
import { FilterColDef } from '../types';
import { useFetchUsers } from './useFetchUsers';

export const isUserField = (value: string) => {
  const listOfUserFields: MetaField[] = [
    'assignees',
    'confirmed_by',
    'deleted_by',
    'exported_by',
    'modifier',
    'rejected_by',
    'creator',
  ];
  return listOfUserFields.some(userField => userField === value);
};

export const useFetchAsyncChipValues = ({
  field,
}: {
  field: string;
}): Partial<FilterColDef> => {
  const { data: allUsers, isLoading: areValuesLoading } = useFetchUsers({
    enabled: isUserField(field),
  });

  if (!isUserField(field)) return {};

  const valueOptions = getModifierValueOptions(allUsers ?? []);

  return { valueOptions, areValuesLoading };
};
